import axios from "axios";
import { accessLocalStorage } from "../helpers/accessLocalStorage";
// const API = "https://api-soe.mof.gov.la/api/v1"; //PROD
// const API =
// 	"https://uu6cip4npc.execute-api.ap-southeast-1.amazonaws.com/dev/api/v1"; //DEV
// const API =
// 	"https://uu6cip4npc.execute-api.ap-southeast-1.amazonaws.com/api/v1"; //PROD GATEWAY

const API = import.meta.env.VITE_API_URL; // Use the environment variable for the base API URL

console.log("API Config", API);

// Create an Axios instance
const axiosInstance = axios.create({
	baseURL: API, // Set the base URL from your APIs constants
	headers: {
		"Content-Type": "application/json",
	},
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
	(config) => {
		const token = {
			accessToken: accessLocalStorage("accessToken"),
			refresh_token: localStorage.getItem("refresh_token"),
		};
		// const token = localStorage.getItem("accessToken");
		// console.log("token ksakdkaslkd:::", token);
		if (token) {
			config.headers.Authorization = `Bearer ${token.accessToken}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default axiosInstance;
